import { Select } from "antd";
import * as React from "react";
import { useStoreActions, useStoreState } from "../../store/hooks/easyPeasy";
const { Option } = Select;

export interface SelectExambySection {
  onChange?: any;
  selected?: any;
  defaultSelected?: any;
  style?: any
}

export const SelectExambySection = ({
  onChange,
  selected,
  defaultSelected,
  style
}: SelectExambySection) => {
  const itemList = useStoreState((state) => state.exam.semesterListByClassConfigIdArray);

  const onSelect = (id) => {
    if (itemList) {
      const value = itemList.find((item) => item.examConfigId === id);
      onChange(value.examConfigId);
    }
  };
  


  return (
    <Select
      onChange={onSelect}
      // loading={loading}
      showSearch
      className="examsectionSelect"
      // allowClear
      defaultValue={defaultSelected}
      value={selected}
      style={style}
      labelInValue={false}
      placeholder="Select Exam"
      filterOption={(input, option:any) =>
        option !== undefined &&
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
    >
      {itemList ? (
        itemList.map((type, idx) => (
          <Option key={type.examConfigId} value={type.examConfigId}>
            {type.examName}
          </Option>
        ))
      ) : (
        <Option value="fetching">Fetching Exam</Option>
      )}
    </Select>
  );
};
